/** community group: network events and announcements (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const communityPermissions = ['event:register'] as const;

export type CommunityPermission = (typeof communityPermissions)[number];
